import React, { useState, useEffect, useRef } from "react";
import {
  useNavigate,
  useLocation,
  useParams,
  useSearchParams,
} from "react-router-dom";

// Styles
import { useTheme } from "@mui/material/styles";
import useStyles from "assets/jss/material-react/views/italmundoStyles";
// Components
import { Box, useMediaQuery, TextField } from "@mui/material";
import PageContainer from "../../components/PageContainer/PageContainer";
import { Redireccion } from "../../components/Modals";
// Assets
import { ValidarDocumentosIcon } from "assets";
// Service
import ClientService from "services/clientService";
import SmsService from "services/smsService";
import {
  incrementPhoneValidationAttempts,
  getPhoneValidationAttempts,
} from "services/sessionStorageService";
import { getSessionDocument } from "services/sessionStorageService";
import { URLs, getURLDespedida, redirectStep } from "../../utils/redirectStep";
import { saveSessionTipoTarjetaPlata } from "services/sessionStorageService";
function VerificacionDeDatos() {
  //Inicializaciones base
  const clientService = new ClientService();
  const smsService = new SmsService();
  const classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const inputRefs = useRef([null, null, null, null, null, null]);
  const location = useLocation();
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [loading, setLoading] = React.useState(false);
  const [modal, setModal] = React.useState({
    open: false,
    title: "",
    message: "",
    content: null,
  });

  // Inicializaciones particulares
  const [errors, setErrors] = useState({});
  const [celular, setCelular] = useState("");
  const [tipoTarjetaPlata, setTipoTarjetaPlata] = useState("");
  const {
    transactionId,
    document,
    idLead,
    pagoAnticipado,
    tipoTarjeta,
  } = useParams();

  const [timer, setTimer] = useState(60);
  const [code, setCode] = useState(["", "", "", "", "", ""]);
  const [searchParams, setSearchParams] = useSearchParams();
  const utmClient = searchParams.get("utm_source");
  const [tipoModal, setTipoModal] = useState(null);
  const urlDespedida = getURLDespedida(utmClient);
  const handleModalCloseClick = () => {
    if (tipoModal === 1) {
      navigate(URLs.home);
    }
    setModal({ ...modal, open: false });
  };

  // timer
  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  const buildNavigateUrl = (path) => {
    const params = new URLSearchParams(searchParams);
    return `${path}?${params.toString()}`;
  };

  // para redirigir
  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
    // Verificar si Web OTP API está disponible
    if ("OTPCredential" in window) {
      const ac = new AbortController();
      navigator.credentials
        .get({
          otp: { transport: ["sms"] },
          signal: ac.signal,
        })
        .then((otp) => {
          setCode(otp.code.split(""));
          verifyCode(otp.code);
        })
        .catch((err) => console.warn("Web OTP API no disponible:", err));
      return () => ac.abort();
    }
    const checkAndRedirect = async () => {
      const documento = getSessionDocument();
      if (!documento) {
        navigate(`/`);
      } else {
        try {
          const response = await clientService.evaluateDocument(documento);
          const codigoEstado = response.data.codigoEstado;
          console.log("response evaluate document verificacion 96", response);
          const transaction = {
            ...response.data,
          };
          // estado pendiente
          if (codigoEstado === 14) {
            setTipoModal(1);
            setModal({
              open: true,
              showX: true,
              message: response.message,
            });
          } else if (codigoEstado != 5) {
            // estamos en el codigo estado de la misma pantalla, entonces no debe redirigir
            openModalRedirect();
            setTimeout(async () => {
              await redirectStep(codigoEstado, transaction, navigate);
            }, 3000);
          }
        } catch (error) {
          console.log(error);
        }
      }
    };
    checkAndRedirect();
  }, []);

  const openModalRedirect = () => {
    setModal({
      open: true,
      showX: false,
      content: <Redireccion />,
    });
  };

  const handleInputChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "");
    if (index === 0 && value.length === 6) {
      const newCode = value.split("");
      setCode(newCode);
    } else {
      const newCode = [...code];
      if (value) {
        newCode[index] = value;
        setCode(newCode);
        if (value && index < code.length - 1) {
          inputRefs.current[index + 1]?.focus();
        }
        if (newCode.every((num) => num !== "")) {
          verifyCode(newCode.join(""));
        }
      } else {
        newCode[index] = "";
        setCode(newCode);
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !code[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").slice(0, code.length);
    if (/^\d+$/.test(pastedData)) {
      const newCode = pastedData.split("");
      setCode(newCode);
      inputRefs.current[newCode.length - 1]?.focus();
    }
  };

  useEffect(async () => {
    const documento = getSessionDocument();
    if (!documento) {
      navigate(`/`);
    }
    const pagoAnticipado = location?.state?.transaction?.pagoAnticipado;
    console.log("location?.state? 175", location?.state);
    if (pagoAnticipado) {
      // va por camino OK
      navigate(buildNavigateUrl(URLs.costoDeActivacion), {
        state: {
          transaction: location.state.transaction,
        },
      });
    }
    if (!transactionId && !document && !idLead && !pagoAnticipado) {
      const newTransaction = {
        transactionId: location?.state?.transaction?.transactionId,
        document: location?.state?.transaction?.document,
        idLead: location?.state?.transaction?.idLead,
        codigoEstado: 5,
      };
      try {
        if (!location?.state?.transaction) {
          navigate(buildNavigateUrl(URLs.intenteNuevamente));
        } else {
          const responseEstado = await clientService.getInfoEstado(
            newTransaction,
          );
          setCelular(responseEstado.data.clientMobile);
          setTipoTarjetaPlata(
            responseEstado.data.ofertaConfirmada.pagoAnticipado,
          );
        }
      } catch (error) {
        navigate(buildNavigateUrl(URLs.intenteNuevamente));
      }
      if (!location?.state?.transaction) {
        navigate(buildNavigateUrl(URLs.intenteNuevamente));
      } else {
        const smsSendResponse = await smsService.send(
          location?.state?.transaction,
        );
        incrementPhoneValidationAttempts();
        if (smsSendResponse.code === 401) {
          setTipoModal(null);
          setModal({
            open: true,
            showX: true,
            message:
              "Ha ocurrido un error, por favor intente reenviando el mensaje.",
          });
        } else if (smsSendResponse.code !== 200) {
          navigate(buildNavigateUrl(URLs.intenteNuevamente));
        }
      }
    }
  }, [transactionId, document, idLead, pagoAnticipado]);

  const verifyCode = async (code) => {
    setLoading(true);
    try {
      const response = await smsService.verify(
        location.state.transaction,
        code,
      );
      if (response.code === 0 && tipoTarjetaPlata === null) {
        navigate(buildNavigateUrl(urlDespedida), {
          state: {
            transaction: location?.state?.transaction,
          },
        });
      } else if (response.code == 0) {
        navigate(buildNavigateUrl(URLs.costoDeActivacion), {
          state: {
            transaction: {
              ...location.state.transaction,
              pagoAnticipado: tipoTarjetaPlata,
            },
          },
        });
      } else if (response.code != 0) {
        navigate(buildNavigateUrl(URLs.intenteNuevamente));
      } else {
        setErrors({});
      }
    } catch (error) {
      navigate(buildNavigateUrl(URLs.intenteNuevamente));
    } finally {
      setLoading(false);
    }
  };

  const handleResendClick = async () => {
    setLoading(true);
    setErrors({});
    setCode(["", "", "", "", "", ""]);
    try {
      if (getPhoneValidationAttempts() >= 4) {
        navigate(buildNavigateUrl(URLs.intenteNuevamente));
      } else {
        incrementPhoneValidationAttempts();
        const response = await smsService.resend(location.state.transaction);
        if (response.code == 200) {
          setTimer(60);
        }
      }
    } catch (error) {
      console.error("Error al reenviar SMS:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageContainer
        loading={loading}
        modal={modal}
        handleModalCloseClick={handleModalCloseClick}
        canonicalUrl={URLs.verificacionCelular}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "start",
              marginTop: "1rem",
              width: mobile ? "90%" : "100%",
            }}
          >
            <img
              src={ValidarDocumentosIcon}
              style={{
                marginRight: "8px",
                width: "24px",
                height: "24px",
              }}
            />
            <p
              style={{
                fontSize: mobile ? "12px" : "15px",
                fontWeight: "520",
              }}
            >
              VERIFICACIÓN DE DATOS
            </p>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              justifyContent: "start",
              marginTop: mobile ? "0.5rem" : "1rem",
              width: mobile ? "90%" : "100%",
            }}
          >
            <p
              style={{
                fontSize: mobile ? "12px" : "14px",
                marginBottom: mobile ? "0.5rem" : "0.7rem",
              }}
            >
              Vamos a validar tu telefono celular.
            </p>
            <p
              style={{
                fontSize: mobile ? "12px" : "14px",
              }}
            >
              Ingresa el código de verificación que enviamos al número{" "}
              <span className="special-font">{celular}</span>.
            </p>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: mobile ? "1rem" : "1.5rem",
            width: mobile ? "90%" : "40%",
          }}
        >
          {code.map((num, index) => (
            <TextField
              inputRef={(ref) => (inputRefs.current[index] = ref)}
              value={code[index]}
              key={index}
              variant="filled"
              className={classes.inputCustom}
              onChange={(e) => handleInputChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              onPaste={handlePaste}
              inputProps={{
                maxLength: index === 0 ? 6 : 1,
                inputMode: "numeric",
                autoComplete: "one-time-code",
                style: {
                  textAlign: "center",
                  color: errors.code ? "red" : "inherit",
                  padding: "5px 0px",
                  fontSize: "25px",
                  fontFamily: "Montserrat",
                },
              }}
              sx={{ width: "15%", maxWidth: "50px" }}
            />
          ))}
        </Box>
        {errors.code && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              width: mobile ? "90%" : "100%",
              marginTop: "1rem",
              color: "red",
              fontWeight: "500",
            }}
          >
            <p
              style={{
                fontSize: mobile ? "12px" : "14px",
              }}
            >
              {errors.code}
            </p>
          </Box>
        )}
        <Box
          sx={{
            marginBottom: "1rem",
            marginTop: "1rem",
            fontSize: mobile ? "12px" : "14px",
            fontWeight: 500,
            maxWidth: "90%",
            textAlign: "center",
          }}
        >
          {timer > 0 ? (
            <>
              Espera <span className="special-font">{timer}</span> segundos para
              volver a enviar el código.
            </>
          ) : (
            "Puedes volver a enviar el código."
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: mobile ? "90%" : "100%",
            justifyContent: mobile ? "" : "center",
            alignItems: "center",
          }}
        >
          <p
            style={{
              fontSize: mobile ? "12px" : "14px",
            }}
          >
            No recibí ningún código,{" "}
            <span
              style={{
                color: timer > 0 ? "#ccc" : "#04808F",
                fontWeight: 600,
                cursor: timer > 0 ? "not-allowed" : "pointer",
                pointerEvents: timer > 0 ? "none" : "auto",
              }}
              onClick={timer > 0 ? null : handleResendClick}
            >
              volver a enviar
            </span>
            .
          </p>
          <p
            style={{
              fontSize: mobile ? "12px" : "14px",
              marginTop: "1rem",
            }}
          >
            <span
              style={{ color: "#04808F", fontWeight: 600, cursor: "pointer" }}
              onClick={() =>
                (window.location.href =
                  "https://api.whatsapp.com/send?phone=59897051530&text=%C2%A1Quiero%20continuar%20con%20mi%20solicitud")
              }
            >
              ¿Ingresaste mal tu número de celular?
            </span>
            .
          </p>
        </Box>
      </PageContainer>
    </>
  );
}

export default VerificacionDeDatos;
